import styled, { css } from 'styled-components';
import Icon from '../Icon';

const alertVariants = {
  success: css`
    border-color: ${({ theme }) => theme.COLORS.LA_PALMA};
  `,
  information: css`
    border-color: ${({ theme }) => theme.COLORS.INFO};
  `,
  warning: css`
    border-color: ${({ theme }) => theme.COLORS.WARNING};
  `,
  error: css`
    border-color: ${({ theme }) => theme.COLORS.ERROR};
  `
};

export const StyledAlert = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  width: 100%;
  flex-wrap: nowrap;
  padding: 5px 25px;
  background: ${({ theme }) => theme.COLORS.BASE};
  border: 1px solid transparent;
  border-left: 9px solid transparent;
  border-radius: 3px;
  ${props => alertVariants[props.variant]};
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: 14px;
  color: #000;
  // The following two media queries ensure that the toast alert is responsive to all screen sizes.
  @media screen and (min-width: 481px) and (max-width: 800px) {
    max-width: 400px;
    width: 100%;
    margin: 0 auto;
  }
  @media (max-width: 480px) {
    width: 100%;
    margin-top: 30px;
  }
  min-height: 48px;
`;

export const StyledIcon = styled(Icon)`
  width: 20px;
  height: 20px;
  margin-right: 14px;
`;

export const StyledMessages = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: center;
  list-style: none;
  list-style-type: none;
  flex: 1;
  margin: ${({ multipleMessages }) => (multipleMessages ? '8px 0 8px 0' : '0')};
  padding: 0;
  flex-wrap: wrap;
`;

export const StyledMessage = styled.li`
  width: 100%;
  margin-bottom: 20px;
  font-family: ${({ theme }) => theme.FONT.REGULAR};
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};

  &:last-child {
    margin-bottom: 0;
  }
`;

export const StyledDismiss = styled.div`
  align-self: flex-start;
  margin-top: ${Props => (Props.isOmp ? '8px' : '0')};
  padding: 0;
`;

export const StyledDismissIcon = styled(Icon).attrs({
  icon: 'TR5-OMPClose'
})`
  width: 20px;
  height: 20px;
  margin-right: 14px;
  cursor: pointer;
`;

export default {
  StyledAlert,
  StyledIcon,
  StyledMessages,
  StyledMessage,
  StyledDismiss,
  StyledDismissIcon
};
